import React, { useState, useEffect } from 'react';
import { Errors } from '../components/common/msg';
import { post } from '../libs/api';
import useInterval from '../libs/useInterval';
import GenericProductCard from './GenericProductCard';

/**
 * GenericProductListing: Displays product cards for a schema.
 * Shows listing page title, description, trade maintenance check, and cards grid.
 */
const GenericProductListing = ({ schema }) => {
  const [isTradeMtn, setIsTradeMtn] = useState(false);
  const [errors, setErrors] = useState([]);

  // Trade maintenance check (same pattern as planscc.js / btcAccumelator.js)
  const checkTradeMtnStatus = async () => {
    try {
      const data = await post('/auth/mtn/trade');
      if (data?.data?.trademtn) {
        setIsTradeMtn(false);
        setErrors([]);
      } else {
        setIsTradeMtn(true);
        setErrors([
          'Investment application is unavailable. Please try again later.',
        ]);
      }
    } catch {
      // In mock mode, ignore maintenance check failures
      setIsTradeMtn(false);
      setErrors([]);
    }
  };

  useEffect(() => {
    checkTradeMtnStatus();
  }, []);

  useInterval(() => {
    checkTradeMtnStatus();
  }, 5000);

  const cards = schema?.cards || [];
  const productType = schema?.productType;

  return (
    <div className="nk-content-body pe-page-shell">
      <div className="nk-block-head text-center pe-hero">
        <span className="pe-eyebrow">Structured Product</span>
        <h2 className="nk-block-title fw-normal">
          {schema?.displayName || 'Products'}
        </h2>
        <div className="nk-block-des w-max-550px m-auto">
          <p>
            <strong>
              {schema?.description ||
                'Choose your preferred investment product to earn high returns.'}
            </strong>
          </p>
        </div>
      </div>

      <div className="nk-ivp-apps">
        <div className="nk-ivp-plans row g-gs scheme-container justify-center pe-listing-grid">
          {errors?.length > 0 && <Errors errors={errors} />}

          {isTradeMtn === false &&
            cards.map((card, i) => (
              <div className="col-md-6 col-lg-6 pe-listing-col" key={i}>
                <GenericProductCard card={card} productType={productType} />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default GenericProductListing;
